import { useEffect, useState, useRef } from 'react';

interface UseNudgeModalOptions {
  /** 表示判定までの待機時間（ミリ秒） */
  delayMs?: number;
  /** 表示確率（0.0〜1.0） */
  probability?: number;
  /** モーダルを表示するかどうかの判定関数 */
  shouldShow?: () => boolean;
}

/**
 * ナッジモーダルの表示制御を行うカスタムフック
 * 
 * @param options - オプション設定
 * @returns モーダルの表示状態と制御関数
 */
export function useNudgeModal(options: UseNudgeModalOptions = {}) {
  const {
    delayMs = 5000, // デフォルト5秒
    probability = 0.3, // デフォルト30%
    shouldShow = () => true,
  } = options;

  const [isVisible, setIsVisible] = useState(false);
  const hasCheckedRef = useRef(false);
  const timerRef = useRef<number | null>(null);

  useEffect(() => {
    // 既に判定済みの場合は何もしない
    if (hasCheckedRef.current) {
      return;
    }

    // タイマーを設定
    timerRef.current = window.setTimeout(() => {
      hasCheckedRef.current = true;

      // 表示条件をチェック
      if (!shouldShow()) {
        return;
      }

      // ランダム確率で表示判定
      if (Math.random() < probability) {
        setIsVisible(true);
      }
    }, delayMs);

    // クリーンアップ
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [delayMs, probability, shouldShow]);

  const close = () => {
    setIsVisible(false);
  };

  return {
    isVisible,
    close,
  };
}
